export default function Hero() {
  return (
    <section 
      className="relative min-h-screen flex items-center justify-center bg-cover bg-center"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.3)), url('https://static.readdy.ai/image/71745ccb8c79f3954a4900c745433851/1592f34450bcdd800552eba2e0ad62af.jpeg')`
      }}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center w-full">
        <div className="max-w-4xl mx-auto">
          <h2 className="text-6xl md:text-8xl font-black text-white mb-6 leading-tight tracking-tight uppercase">
            Orelle Freeski
          </h2>
          <p className="text-2xl md:text-3xl text-white mb-12 leading-relaxed font-light tracking-wide">
            Sécurité • Freeride • Freestyle • Préparation Physique
          </p>
          <div className="flex flex-col sm:flex-row gap-6 justify-center">
            <a 
              href="mailto:contact@esf-orelle.fr" 
              className="bg-white text-black px-10 py-5 text-lg font-bold hover:bg-gray-200 transition-all transform hover:scale-105 cursor-pointer whitespace-nowrap inline-flex items-center justify-center tracking-wide uppercase"
            >
              <i className="ri-mail-line mr-3 text-xl"></i>
              Nous Contacter
            </a>
            <a 
              href="#services" 
              className="bg-transparent border-2 border-white text-white px-10 py-5 text-lg font-bold hover:bg-white hover:text-black transition-all cursor-pointer whitespace-nowrap inline-flex items-center justify-center tracking-wide uppercase"
            >
              Découvrir
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}